module.exports = __webpack_public_path__ + "8bcede6133e8c04278c5ba83caa509f6.svg";